import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { DateRangePicker } from "react-dates";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";
import Select from "react-select";
import {
  Alert,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Label,
  Row,
} from "reactstrap";
import { bindActionCreators } from "redux";
import { layout, messages, roles } from "../../../../common/constants";
import { DataTable, ExportCSV } from "../../../../components";
import { getNewClients as newClientsExport } from "../../../../service/dashboard";
import { getNewClients } from "../../../../store/dashboard/actions";
import { getStores } from "../../../../store/store/actions";
import { selectStoresForSelect } from "../../../../store/store/selector";
import { selectUserRole } from "../../../../store/user/selector";
import { exportExcel } from "./excel";
import * as columns from "./_columns";
class CardNewClients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNewClients: true,
      startDate: null,
      endDate: null,
      focusedInput: null,
      loadingExport: false,
      selectedStore: null,
    };
    this.handleObtainNewClientsExport =
      this.handleObtainNewClientsExport.bind(this);
  }

  renderDataTable(columns) {
    if (this.props.newClients)
      return (
        <DataTable
          data={this.props.newClients}
          keyField="id"
          columns={columns}
          loading={this.props.loading}
        />
      );
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });
    if (
      this.state.startDate &&
      this.state.endDate &&
      this.state.selectedStore
    ) {
      await this.props.getNewClients({
        startDate: this.state.startDate._d,
        endDate: this.state.endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  handleDateChange(startDate, endDate) {
    this.setState({ startDate, endDate });
    if (startDate != null && endDate != null && this.state.selectedStore) {
      this.props.getNewClients({
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  handleObtainNewClientsExport() {
    const { selectedStore, startDate, endDate } = this.state;
    this.setState({ loadingExport: true });
    newClientsExport(startDate._d, endDate._d, selectedStore.value).then(
      (response) => {
        exportExcel(response.data.data, selectedStore, startDate, endDate);
        this.setState({ loadingExport: false });
      }
    );
  }

  render() {
    const { startDate, endDate } = this.state;
    return (
      <Card>
        <CardHeader
          onClick={() =>
            this.setState({ showNewClients: !this.state.showNewClients })
          }
        >
          Nuevos Clientes
        </CardHeader>
        <Collapse isOpen={this.state.showNewClients}>
          <CardBody>
            <MediaQuery minDeviceWidth={layout.SM_MIN_WIDTH}>
              {(matches) => {
                if (matches) {
                  return (
                    <div>
                      <Row className="mb-2">
                        <Col md="4">
                          <DateRangePicker
                            startDate={startDate}
                            startDateId="startDate"
                            endDate={endDate}
                            endDateId="endDate"
                            displayFormat={"DD/MM/YYYY"}
                            onDatesChange={({ startDate, endDate }) =>
                              this.handleDateChange(startDate, endDate)
                            }
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) =>
                              this.setState({ focusedInput })
                            }
                            startDatePlaceholderText="Fecha Inicio"
                            endDatePlaceholderText="Fecha Fin"
                            small
                            isOutsideRange={() => false}
                            hideKeyboardShortcutsPanel
                            minimumNights={0}
                          />
                        </Col>
                        <Col md="5">
                          {(this.props.role == roles.SUPER_ADMIN ||
                            this.props.role == roles.ADMIN) && (
                            <Row>
                              <Col sm="4">
                                <Label className="mt-2">TIENDA:</Label>
                              </Col>
                              <Col sm="8">
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  isLoading={this.props.loadingStores}
                                  isSearchable={true}
                                  noOptionsMessage={() => {
                                    return messages.SELECT_NO_OPTIONS;
                                  }}
                                  placeholder=""
                                  options={this.props.stores}
                                  loadingMessage={() => {
                                    return messages.SELECT_LOADING;
                                  }}
                                  onChange={this.handleStoreChange.bind(this)}
                                  value={this.state.selectedStore}
                                  isDisabled={this.props.loadingStores}
                                />
                              </Col>
                            </Row>
                          )}
                        </Col>
                        <Col md="3">
                          {this.state.startDate && this.state.endDate ? (
                            <ExportCSV
                              disabled={this.state.loadingExport}
                              exportCSV={this.handleObtainNewClientsExport}
                              minWidth={layout.MD_MIN_WIDTH}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    </div>
                  );
                } else {
                  return (
                    <div>
                      <Row>
                        <Col md="5">
                          {(this.props.role == roles.SUPER_ADMIN ||
                            this.props.role == roles.ADMIN) && (
                            <Row>
                              <Col sm="4">
                                <Label className="mt-2">TIENDA:</Label>
                              </Col>
                              <Col sm="8">
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  isLoading={this.props.loadingStores}
                                  isSearchable={true}
                                  noOptionsMessage={() => {
                                    return messages.SELECT_NO_OPTIONS;
                                  }}
                                  placeholder=""
                                  options={this.props.stores}
                                  loadingMessage={() => {
                                    return messages.SELECT_LOADING;
                                  }}
                                  onChange={this.handleStoreChange.bind(this)}
                                  value={this.state.selectedStore}
                                  isDisabled={this.props.loadingStores}
                                />
                              </Col>
                            </Row>
                          )}
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col md="4">
                          <DateRangePicker
                            startDate={startDate}
                            startDateId="startDate"
                            endDate={endDate}
                            endDateId="endDate"
                            displayFormat={"DD/MM/YYYY"}
                            onDatesChange={({ startDate, endDate }) =>
                              this.handleDateChange(startDate, endDate)
                            }
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) =>
                              this.setState({ focusedInput })
                            }
                            startDatePlaceholderText="Fecha Inicio"
                            endDatePlaceholderText="Fecha Fin"
                            small
                            numberOfMonths={1}
                            isOutsideRange={() => false}
                            hideKeyboardShortcutsPanel
                          />
                        </Col>
                        <Col md="3">
                          {this.state.startDate && this.state.endDate ? (
                            <ExportCSV
                              disabled={this.state.loadingExport}
                              exportCSV={this.handleObtainNewClientsExport}
                              minWidth={layout.MD_MIN_WIDTH}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    </div>
                  );
                }
              }}
            </MediaQuery>

            <hr className="my-4" />
            {startDate != null && endDate != null ? (
              <div>
                <Row>
                  <Col xl="7">
                    <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                      {this.renderDataTable(columns.newClientsXS)}
                    </MediaQuery>
                    <MediaQuery
                      minWidth={layout.SM_MIN_WIDTH}
                      maxWidth={layout.MD_MAX_WIDTH}
                    >
                      {this.renderDataTable(columns.newClientsSM)}
                    </MediaQuery>
                    <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                      {this.renderDataTable(columns.newClients)}
                    </MediaQuery>
                  </Col>
                </Row>
              </div>
            ) : (
              <Row>
                <Col>
                  <Alert color="info">
                    Seleccione una fecha para visualizar los datos
                  </Alert>
                </Col>
              </Row>
            )}
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}

function mapStateToProps(state) {
  const { newClients, total, error, loading } = state.dashboard.newClientsList;
  return {
    newClients,
    total,
    error,
    loading,
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getNewClients,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CardNewClients);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardNewClients/CardNewClients.js